
import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {Container,Card,Button} from "react-bootstrap";
import axios from 'axios';
import AdminDashboardLayout from "../../../Components/AdminDashboard/AdminDashboardLayout";
import Loading from 'react-fullscreen-loading';
import { toast } from "react-hot-toast";
import Select from 'react-select'
import countryList from 'react-select-country-list';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import '../../../Pages/User/Auth/Signup/phone-input.css';
import { useRoles } from '../../../utils/useRoles';
import { useAuth } from '../../../authentication/AuthContext';

export default function AddUser() {
  const navigate = useNavigate();
  const [screenloader,setScreenloader] = useState(false);
  const [email, setEmail] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [country, setCountry] = useState("");
  const [organization, setOrganization] = useState("");
  const [password, setPassword] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  // A user is assigned a ROLE; the portal (Users.type) is derived from it on the
  // server, so the form never sends a type of its own — that is what keeps the
  // two from drifting apart.
  const [roleId, setRoleId] = useState(null);
  const [resellerId, setResellerId] = useState("");
  const { roleOptions, loading: rolesLoading } = useRoles();
  // Choosing a new user's role needs admin.users.update_role. Without it the
  // picker is hidden and the server creates the user as a customer.
  const { can } = useAuth();
  const canChooseRole = can('admin.users.update_role');

  const selectedRole = roleOptions.find(opt => opt.value === roleId) || null;
  // The reseller code only means anything for a customer-portal role.
  const isCustomerRole = canChooseRole ? selectedRole?.userType === 'user' : true;

  const [emailError, setEmailError] = useState("");
  const [fnameError, setFnameError] = useState("");
  const [lnameError, setLnameError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [organizationError, setOrganizationError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");

  const options = useMemo(() => countryList().getData(), [])

  const AddUser = async () => {
    setScreenloader(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/admin/users/`, {
        email: email,
        fname: fname,
        lname: lname,
        country: country.label,
        organization: organization,
        password: password,
        phone_number: phoneNumber,
        ...(canChooseRole ? { role_id: roleId } : {}),
        reseller_id: (isCustomerRole && resellerId !== '') ? parseInt(resellerId) : null,
      }, {
        headers: {
          'access-token': localStorage.getItem('accessToken'),
        }
      });
  
      setTimeout(() => {
        setScreenloader(false);
        navigate("/admin/users");
      }, 1500);
  
      if (res.data.status) {
        toast.success('User has been added');
        setEmail("");
        setFname("");
        setLname("");
        setCountry("");
        setOrganization("");
        setPassword("");
        setPhoneNumber("");
        setRoleId(null);
        setResellerId("");
      } else {
        if (res.data.message) {
          toast.error(res.data.message);
        } else {
          toast.error('Something Went Wrong');
          console.log(res.data);
        }
      }
    } catch (er) {
      setScreenloader(false);
      if (er.response?.data?.message) {
        toast.error(er.response.data.message);
      } else {
        console.log(er);
        toast.error("Something Went Wrong");
      }
    }
  };
  

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setEmailError("");
    setFnameError("");
    setLnameError("");
    setCountryError("");
    setOrganizationError("");
    setPasswordError("");
    setPhoneNumberError("");

    // Validation checks
    let isValid = true;
    if (fname === "") {
      setFnameError("First Name is required");
      isValid = false;
    }
    if (lname === "") {
      setLnameError("Last Name is required");
      isValid = false;
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      setEmailError("Invalid email address");
      isValid = false;
    }
    if (country === "") {
      setCountryError("Country is required");
      isValid = false;
    }
    if (organization === "") {
      setOrganizationError("Organization is required");
      isValid = false;
    }
    if (password === "") {
      setPasswordError("Password is required");
      isValid = false;
    }
  
    if (isValid) {
      setScreenloader(true);
      try {
        //this will clear fileds after user has been added
        await AddUser();
      } catch (error) {
        console.error("Error occurred during user addition:", error);
      } finally {
        setScreenloader(false);
      }
    }
  };
  
 const labelStyles = {
      fontWeight: "bold",
      fontSize: "14px", 
  };

const customStyles = {
  control: (base) => ({
    ...base,
    borderColor: '#dee2e6',
    boxShadow: 'none',
    '&:hover': { borderColor: '#dee2e6' }
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#5f75a5" : "white",
    color: state.isFocused ? "white" : "#333",
    cursor: 'pointer',
  }),
  menuPortal: base => ({ ...base, zIndex: 9999 }) // Fixes depth issue
};
  return (
    <div>
      <AdminDashboardLayout />
      <Loading loading={screenloader} background="#fff" loaderColor="#883484" />
      <div className='content-page-bg'>
        <div className='content-page'>
          <div className='content'>
            <h2>Add User</h2>
            <p className="text-muted">A user will created with the given email and password.</p>
            <Container fluid className='behind'>
              <Card className='mt-4'>
                <Card.Body>
                  <form onSubmit={handleFormSubmit}>
                  <div className="row">
                      <div className="col-md-12">
                      <div className="mb-3">
                          <label htmlFor="email" className="form-label" style={labelStyles}>
                              Email
                          </label>
                          <input
                              type="email"
                              className="form-control"
                              id="email"
                              placeholder='Enter your Email'
                              value={email}
                              onChange={(e) => {setEmail(e.target.value);setEmailError("")}}
                          />
                          {emailError && <div className="d-flex invalid-feedback">{emailError}</div>}
                        </div>
                      </div>

                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                        <label htmlFor="firstname" className="form-label" style={labelStyles}>
                            First Name
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="firstname"
                            placeholder='Enter your First Name'
                            value={fname}
                            onChange={(e) => {setFname(e.target.value);setFnameError("")}}
                        />
                        {fnameError && <div className="d-flex invalid-feedback">{fnameError}</div>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="lastname" className="form-label" style={labelStyles}>
                              Last Name
                          </label>
                          <input
                              type="text"
                              className="form-control"
                              id="lastname"
                              placeholder='Enter your Last Name'
                              value={lname}
                              onChange={(e) => {setLname(e.target.value);setLnameError("")}}
                          />
                          {lnameError && <div className="d-flex invalid-feedback">{lnameError}</div>}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="country" className="form-label" style={labelStyles}>
                              Country
                          </label>
                          <Select placeholder="Select your Country" options={options} value={country} onChange={(e) => {setCountry(e);setCountryError("")}} />
                          {countryError && <div className="d-flex invalid-feedback">{countryError}</div>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="organization" className="form-label" style={labelStyles}>
                              Organization
                          </label>
                          <input
                              type="text"
                              className="form-control"
                              id="organization"
                              placeholder='Your Organization'
                              value={organization}
                              onChange={(e) => {setOrganization(e.target.value);setOrganizationError("");}}
                          />
                          {organizationError && <div className="d-flex invalid-feedback">{organizationError}</div>}
                        </div> 
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="password" className="form-label" style={labelStyles}>
                              Password
                          </label>
                          <input
                              type="text"
                              className="form-control"
                              id="password"
                              placeholder='Enter your Password'
                              value={password}
                              onChange={(e) => {setPassword(e.target.value);setPasswordError("")}}
                          />
                          {passwordError && <div className="d-flex invalid-feedback">{passwordError}</div>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="phoneNumber" className="form-label" style={labelStyles}>
                              Phone Number
                          </label>
                          <div className="PhoneInput-wrapper">
                            <PhoneInput
                                international
                                placeholder="Enter phone number"
                                value={phoneNumber}
                                onChange={setPhoneNumber}
                                id="phoneNumber"
                            />
                          </div>
                          {phoneNumberError && <div className="d-flex invalid-feedback">{phoneNumberError}</div>}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="role" className="form-label" style={labelStyles}>Role</label>
                          {!canChooseRole ? (
                            <div className="form-control" style={{ background: '#f8fafc' }}>
                              Customer <small className="text-muted">— you don't have permission to choose a role</small>
                            </div>
                          ) : (
                          <Select
                              id="role"
                              options={roleOptions}
                              styles={customStyles}
                              isLoading={rolesLoading}
                              placeholder={rolesLoading ? "Loading roles…" : "Select a role"}
                              value={selectedRole}
                              onChange={(e) => {
                                setRoleId(e.value);
                                if (e.userType !== 'user') setResellerId("");
                              }}
                              // Fixes the screen cutoff issue
                              menuPortalTarget={document.body}
                              menuPlacement="auto"
                            />
                          )}
                        </div>
                      </div>
                      {isCustomerRole && (
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label htmlFor="resellerId" className="form-label" style={labelStyles}>
                              Reseller ID <span className="text-muted fw-normal" style={{fontSize:'12px'}}>(optional)</span>
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id="resellerId"
                              placeholder="Reseller Profile ID"
                              value={resellerId}
                              onChange={(e) => setResellerId(e.target.value)}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="d-flex flex-column flex-sm-row gap-2 mb-3">
                      <Button className="btn admin-btn" type="submit">
                        Create {selectedRole ? selectedRole.label : 'User'}
                      </Button>
                      <Button style={{ backgroundColor: '#5f75a5ff', color: '#d8d6d6ff', border: 'none'}} onClick={()=>{navigate(-1)}} variant="danger">Back</Button>
                    </div>  
                  </form>
                </Card.Body>
              </Card>
            </Container>
          </div>
        </div>
      </div>
    </div>
  );
}
